import Vue from 'vue'
import Router from 'vue-router'
import MapComponent from './components/map/map.component'
import MapCompareComponent from './components/map-compare/map-compare.component'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/:uid/map-compare',
      name: 'map-compare',
      component: MapCompareComponent,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:uid',
      name: 'home',
      component: MapComponent,
      meta: {
        requiresAuth: true
      }
    }
  ]
})
export default router;
